import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import Icon from '@material-ui/core/Icon'
import CheckIcon from '@material-ui/icons/Check'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'

import Y from '../y18n'
import * as globalMessageActions from '../store/global-message'

const styles = theme => ({
  globalSuccess: {
    color: '#3c763d',
    backgroundColor: '#dff0d8',
    borderColor: '#3c763d'
  },
  globalError: {
    color: '#a94442',
    backgroundColor: '#f2dede',
    borderColor: '#a94442'
  },
  globalWarning: {
    color: '#c19445',
    backgroundColor: '#fcf8e3',
    borderColor: '#faebcc'
  },
  marginRight: {
    marginRight: '10px'
  },
  row: {
    display: 'flex',
    aligntItems: 'center'
  }
})

const mapStateToProps = state => ({
  state: state.globalMessage
})
const mapDispatchToProps = dispatch => ({
  globalMessageActions: bindActionCreators(globalMessageActions, dispatch)
})

class GlobalMessageSnackbar extends Component {
  handleRequestClose = () => {
    this.props.globalMessageActions.resetMessage()
  }

  render () {
    const { classes, state } = this.props
    if (!state || !state.message) return null

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={state.message !== null}
        autoHideDuration={3000}
        onClose={this.handleRequestClose}
        ContentProps={{
          'aria-describedby': 'message-id',
          classes: {
            root: state.status === 'success'
              ? classes.globalSuccess
              : state.status === 'error'
                  ? classes.globalError
                  : state.status === 'warning' ? classes.globalWarning : ''
          }
        }}
        message={
          <div id='message-id'>
            <div className={classes.row}>
              <Icon className={classes.marginRight}>
                {state.status === 'success'
                  ? <CheckIcon />
                  : state.status === 'warning' ? <WarningIcon /> : <ErrorIcon />}
              </Icon>
              <span>{Y`${state.message}`}</span>
            </div>
          </div>
        }
      />
    )
  }
}

GlobalMessageSnackbar = connect(mapStateToProps, mapDispatchToProps)(GlobalMessageSnackbar)
export default withStyles(styles)(GlobalMessageSnackbar)



// WEBPACK FOOTER //
// ./src/common/global-message-snackbar.js